/**
 * Gate minimo per rotte admin frontend-first.
 * Preferisce token Super Admin; accetta flag demo `6amico_admin`.
 */

export function is6AmicoAdmin() {
  if (typeof window === "undefined") return false;
  if (localStorage.getItem("6amico_admin_token")) return true;
  return localStorage.getItem("6amico_admin") === "1";
}

export function set6AmicoAdminFlag(enabled = true) {
  if (typeof window === "undefined") return;
  if (enabled) localStorage.setItem("6amico_admin", "1");
  else localStorage.removeItem("6amico_admin");
}
